'use strict';

(function() { // jshint ignore:line

    var petitionOutdated = true;
    var updatingPetition = true;
    var doRequest =  new Promise((resolve, reject) => {
        var request = new XMLHttpRequest();
        
        request.open('GET', 'https://time.akamai.com/?iso', true);

        request.onload = function() {
            if (request.status >= 200 && request.status < 400) {
                resolve(request);
            } else {
                resolve(moment());
            }
        };

        request.onerror = function() {
            resolve(moment());
        };

        request.send();

    });
    // doRequest.then(function(){});
    angular.module('itxApp.preCommon').factory('AkamaiDateSvc', ['$q', function($q) {
        var time;
        var timeForNewPetition = 120000;
        var pendingPetitions = [];
        var refreshPetition = null;

        doRequest.then(function(request){
            createTimeWithAkamai(request.responseText);
            validatePetition();
        });

        function invalidatePetition() {
            petitionOutdated = true;
        }

        function validatePetition() {
            petitionOutdated = false;
            updatingPetition = false;
            resolvePendingPetitions();

            if(refreshPetition){
                clearTimeout(refreshPetition);
            }
            refreshPetition = setTimeout(function(){
                invalidatePetition();
            },timeForNewPetition);
        }

        function updatePetition(){
            updatingPetition = true;

            var request = new XMLHttpRequest();

            request.open('GET', 'https://time.akamai.com/?iso', true);
            
            request.onload = function() {
                if (request.status >= 200 && request.status < 400) {
                    createTimeWithAkamai(request.responseText);
                } else {
                    createTimeWithLocal();
                }
                validatePetition();
            };

            request.onerror = function() {
                createTimeWithLocal();
                validatePetition();
            };

            request.send();
            
        }

        function createTimeWithAkamai(akamaiString){
            time = moment(akamaiString);
            window.date = time;
            executeTimeTraveler();
        }

        function createTimeWithLocal(){
            time = moment();
            window.date = time;
            executeTimeTraveler();
        }

        function addPendingPetition(petition){
            pendingPetitions.push(petition);
        }

        function resolvePendingPetitions(){
            var t = time.clone();
            for(var index in pendingPetitions){
                pendingPetitions[index].resolve(t);
            }
            pendingPetitions = [];
        }

        function executeTimeTraveler() {

            if (document.location.search.indexOf('time_traveler') > -1) {
                //2016-04-04-24:03:03
                var params = {};
                location.search.replace(/[?&]+([^=&]+)=([^&]*)/gi, function(s, k, v) {
                    params[k] = v;
                });

                if (!params['time_traveler']) {
                    return;
                }
                
                var timeTravelerValue = params['time_traveler'].replace(new RegExp('%3A', 'g'), ':');
                time = moment(timeTravelerValue, 'YYYY-MM-DD-HH:mm:ss');

                if (time.isValid()) {
                    window.date = time;
                }
            }
        }

        function _getDate(){
            var deferred = $q.defer();
            if(!petitionOutdated){
                if(time){
                    deferred.resolve(time.clone());
                }
                else {deferred.resolve(moment());}
                
            } else {
                addPendingPetition(deferred);
                if(!updatingPetition){
                    updatePetition();
                }
            }

            return deferred.promise;
        }

        function _getLocalDate(tz){
            var deferred = $q.defer();
            _getDate()
            .then(currentDate => {
                const localString = _getLocalStringFromMoment(currentDate, tz);
                const akamaiLocalMoment = moment.tz(localString, 'YYYY-MM-DDTHH:mm:ss', tz);
                deferred.resolve(akamaiLocalMoment);
            });

            return deferred.promise;
        }

        function _getLocalStringFromMoment(imoment, tz){
            const utcString = imoment._i;
            return _transformUtcToLocal(utcString, tz);
        }

        function _transformUtcToLocal(utcString, tz){
            const tzString = moment(utcString, 'YYYY-MM-DDTHH:mm:ssZ').tz(tz).format('YYYY-MM-DDTHH:mm:ss');
            return tzString;
        }


        function _getForcedCurrentDate(){
            var deferred = $q.defer();
            
            addPendingPetition(deferred);
            if(!updatingPetition){
                updatePetition();
            }

            return deferred.promise;
        }

        return {
            getDate: _getDate,
            getForcedCurrentDate: _getForcedCurrentDate,
            transformUtcToLocal: _transformUtcToLocal,
            getLocalStringFromMoment: _getLocalStringFromMoment,
            getLocalDate: _getLocalDate
        };
    }]);

})();